module.exports = __webpack_public_path__ + "img/share_img@2x.9a3f5a05.png";